import keyBy from 'lodash/keyBy';
import { useArticlesThemesContext } from '@/creditflowresearch/application/ArticlesAndStats/ArticlesMarketThemesContext';

const ArticleTypesCell = ({ row }) => {
  const { themes, isInitialized: isThemesInitialized } = useArticlesThemesContext();

  if (!isThemesInitialized) {
    return '-';
  }

  const groupedThemesById = keyBy(themes, 'id');
  const types = row.themes.reduce((acc, themeId) => {
    const { type } = groupedThemesById[themeId];

    return acc.includes(type) ? acc : [...acc, type];
  }, []);

  if (!types.length) {
    return '-';
  }

  return types.join(', ');
};

export default ArticleTypesCell;
